var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeriodoDePago(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A53535"
    },
    cx: 256,
    cy: 267,
    r: 245
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD00D"
    },
    cx: 80.38,
    cy: 257.24,
    r: 34.503
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF10"
    },
    d: "M65.723,257.242c0-15.606,10.364-28.786,24.582-33.048c-3.143-0.942-6.472-1.455-9.922-1.455 c-19.055,0-34.503,15.448-34.503,34.503s15.448,34.503,34.503,34.503c3.45,0,6.779-0.513,9.922-1.455 C76.087,286.027,65.723,272.848,65.723,257.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91E0E8"
    },
    d: "M407.896,185.208c-43.599,0-80.219-30.452-89.711-71.203H106.273c-5.5,0-10,4.5-10,10v116.976 c0,5.5,4.5,10,10,10h299.453c5.5,0,10-4.5,10-10v-56.109C413.145,185.09,410.533,185.208,407.896,185.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M116.116,240.981V124.005c0-5.5,4.5-10,10-10h-19.843c-5.5,0-10,4.5-10,10v116.976 c0,5.5,4.5,10,10,10h19.843C120.616,250.981,116.116,246.481,116.116,240.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37C47A"
    },
    d: "M235.499,458.876v52.263C242.26,511.699,249.095,512,256,512c34.653,0,67.618-7.21,97.499-20.187 v-32.937L235.499,458.876L235.499,458.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#02AF8E"
    },
    d: "M255.342,458.883h-19.843v52.263c6.546,0.542,13.162,0.835,19.843,0.854V458.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE2B8"
    },
    d: "M355.547,410.039V284.467c0-8.25-6.75-15-15-15h-5.998c-5.931,0-11.071,3.497-13.501,8.523 c-2.43-5.026-7.57-8.523-13.501-8.523h-5.998c-5.931,0-11.071,3.497-13.501,8.523c-2.43-5.026-7.57-8.523-13.501-8.523h-5.998 c-4.901,0-9.261,2.393-12.002,6.058v-58.392c0-8.25-6.75-15-15-15h-5.998c-8.25,0-15,6.75-15,15v122.96l-16.686-16.686 c-5.834-5.833-15.379-5.833-21.213,0.001l-6.241,6.241c-5.833,5.834-5.833,15.38,0,21.213l59.177,59.177L355.547,410.039 L355.547,410.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC987"
    },
    d: "M255.429,410.039l-59.177-59.177c-5.833-5.833-5.833-15.379,0-21.213l6.241-6.241 c0.22-0.22,0.455-0.415,0.686-0.619c-5.873-5.19-14.914-4.996-20.528,0.619l-6.241,6.241c-5.833,5.834-5.833,15.38,0,21.213 l59.177,59.177H255.429z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F9390"
    },
    d: "M365.499,454.876c0,2.75-2.25,5-5,5h-132c-2.75,0-5-2.25-5-5v-40.837c0-2.75,2.25-5,5-5h132 c2.75,0,5,2.25,5,5V454.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F9390"
    },
    d: "M243.342,454.876v-40.837c0-2.75,2.25-5,5-5h-19.843c-2.75,0-5,2.25-5,5v40.837c0,2.75,2.25,5,5,5 h19.843C245.592,459.876,243.342,457.626,243.342,454.876z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 339.5,
    cy: 434.46,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.499,188.5c-4.143,0-7.5-3.358-7.5-7.5v-15c0-4.142,3.357-7.5,7.5-7.5s7.5,3.358,7.5,7.5v15 C244.999,185.142,241.642,188.5,237.499,188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M262.248,198.751c-1.919,0-3.839-0.732-5.304-2.197c-2.929-2.929-2.929-7.678,0-10.606 l10.607-10.607c2.93-2.929,7.678-2.929,10.607,0s2.929,7.678,0,10.607l-10.606,10.606 C266.087,198.019,264.167,198.751,262.248,198.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M287.499,223.5H272.5c-4.143,0-7.5-3.358-7.5-7.5s3.357-7.5,7.5-7.5h14.999 c4.143,0,7.5,3.358,7.5,7.5S291.642,223.5,287.499,223.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M202.497,223.5h-14.998c-4.143,0-7.5-3.358-7.5-7.5s3.357-7.5,7.5-7.5h14.998 c4.143,0,7.5,3.358,7.5,7.5S206.64,223.5,202.497,223.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M212.749,198.75c-1.919,0-3.839-0.732-5.304-2.197l-10.605-10.605 c-2.929-2.929-2.929-7.678,0-10.607c2.93-2.929,7.678-2.929,10.607,0l10.605,10.605c2.929,2.929,2.929,7.678,0,10.606 C216.588,198.018,214.668,198.75,212.749,198.75z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EF9614"
    },
    cx: 407.9,
    cy: 93.1,
    r: 93.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD00D"
    },
    cx: 407.9,
    cy: 93.1,
    r: 66.17
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF10"
    },
    d: "M361.569,93.104c0-33.171,24.41-60.639,56.247-65.426c-3.236-0.487-6.549-0.743-9.921-0.743 c-36.545,0-66.169,29.625-66.169,66.169s29.624,66.169,66.169,66.169c3.372,0,6.685-0.256,9.921-0.743 C385.979,153.743,361.569,126.276,361.569,93.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB722C"
    },
    d: "M420.896,85.937h-23.5V75.604h28.5c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-10.5v-6.5 c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v6.5h-5.5c-6.893,0-12.5,5.607-12.5,12.5v15.333c0,6.893,5.607,12.5,12.5,12.5h23.5 v10.334h-28.5c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h10.5v5.833c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-5.833h5.5 c6.893,0,12.5-5.607,12.5-12.5V98.437C433.396,91.544,427.788,85.937,420.896,85.937z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EF9614"
    },
    cx: 92.1,
    cy: 422.04,
    r: 81.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD00D"
    },
    cx: 92.1,
    cy: 422.04,
    r: 54.641
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF10"
    },
    d: "M57.307,422.038c0-26.788,19.281-49.057,44.719-53.726c-3.219-0.591-6.531-0.915-9.921-0.915 c-30.178,0-54.641,24.464-54.641,54.641c0,30.178,24.463,54.641,54.641,54.641c3.39,0,6.702-0.325,9.921-0.915 C76.588,471.095,57.307,448.825,57.307,422.038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB722C"
    },
    d: "M103.429,414.828H83.925v-7.068h23.86c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-8.181v-4.696 c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v4.696H80.78c-6.537,0-11.855,5.318-11.855,11.855v13.357 c0,6.537,5.318,11.855,11.855,11.855h19.505v7.068h-23.86c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h8.18v4.115 c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-4.115h3.824c6.538,0,11.856-5.318,11.856-11.855v-13.357 C115.285,420.146,109.967,414.828,103.429,414.828z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD00D"
    },
    cx: 424.39,
    cy: 326.25,
    r: 34.503
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF10"
    },
    d: "M409.728,326.247c0-15.606,10.364-28.786,24.582-33.048c-3.142-0.942-6.472-1.455-9.922-1.455 c-19.055,0-34.503,15.448-34.503,34.503c0,19.056,15.448,34.503,34.503,34.503c3.45,0,6.779-0.513,9.922-1.455 C420.093,355.032,409.728,341.853,409.728,326.247z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriodoDePago);
export default __webpack_public_path__ + "static/media/periodo_de_pago.3bcc12ed3950b01e1cb4373c414d3321.svg";
export { ForwardRef as ReactComponent };